<div class='issue-group' [id]='patternIssueGroup.pattern.patternId' [class.selected]='isSelected'>
  <div class='issue-group-heading-outer' [class.selected]='isSelected'>
    <a (click)="navigateToPattern(patternIssueGroup.pattern.patternId)">
      <div class='issue-group-heading'>
        <h2>{{patternIssueGroup.pattern.name}}</h2>
      </div>
    </a>
  </div>
  @if (shouldDisplayGeneralIssues) {
    <div class='issue-group-list'>
      @for (issue of patternIssueGroup.generalIssues; track issue) {
        <div class='issue-group-list-item-wrapper line-indicatable-validated' [ngClass]='getIssueIndicationCssClass(issue)'>
          <div class='issue-group-list-item'>
            <adm4-validation-issue [issue]="issue"></adm4-validation-issue>
          </div>
        </div>
      }
    </div>
  }
  @if (shouldDisplayDeploymentHosts) {
    <adm4-deployment-host [readOnly]='true'
      [form]='patternIssueGroup.form'
      [fcName]='deploymentHostsFormControlName'
      [issues]='patternIssueGroup.deploymentHostIssues'
    ></adm4-deployment-host>
  }
  <adm4-property-list [propertiesModel]='patternIssueGroup.propertiesData'
    [pattern]='patternIssueGroup.pattern'
    [projectKey]='projectKey'
    [variables]='variables'
    [form]='patternIssueGroup.form'
    [readOnly]='true'
  ></adm4-property-list>
</div>
